/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { NativeSupportHandlerV2, NativeSupportHandlerLegacy } from '@bharatpe/native-support-handler';
import { saveState, loadState, removeState } from './LocalStorage';
import Toasty from '../components/atoms/Toasty';
import {
	TOKEN_SESSION_KEY,
	LATITUDE,
	LONGITUDE,
	MODULE_DEEPLINKS,
	MSG_CONSTANT,
	APP_VERSION,
	LOCALE,
} from './CONSTANT';
import { isIOS } from './Utils';

export const getURLParameter = (qrString: string, paramName: string) => {
	try {
		const qr = qrString.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
		const regex = new RegExp(`[\\?&]${paramName}=([^&#]*)`);
		const results = regex.exec(qr);

		return results && results.length > 0 ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

export const initNativeSupport = async () => {
	try {
		await NativeSupportHandlerV2?.init();
		subScribeBackButton();
		const pageRoute = getURLParameter(window.location.href, 'pageRoute') || '';
		if (pageRoute === 'redirectToHomeV2') {
			openDeepLinkWithoutCallback(`${MODULE_DEEPLINKS.PAYMENT_DASHBOARD}?wroute=swipe`);
			return;
		}

		const tokenFromUrl =
			getURLParameter(window.location.href, 'visa') || getURLParameter(window.location.href, 'token');

		const appInfo = JSON.parse(await NativeSupportHandlerLegacy.getAppInfo());
		const { token, locale = '', appversion } = appInfo;

		const versionThreshold = isIOS() ? 310 : 703000;
		const selectedToken = Number(appversion) >= versionThreshold ? token : tokenFromUrl;

		const latitude = getURLParameter(window.location.href, 'latitude');
		const longitude = getURLParameter(window.location.href, 'longitude');

		saveState(TOKEN_SESSION_KEY, selectedToken, true);
		saveState(APP_VERSION, appversion, true);
		saveState(LOCALE, locale, true);
		saveState(LATITUDE, latitude);
		saveState(LONGITUDE, longitude);
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

export const closeNativeSupport = () => {
	sendPlotlineEvent('back_event_swipe', 'trigger');
	NativeSupportHandlerV2?.closeWebView()
		.then((res) => console.log(res)) // eslint-disable-line no-console
		.catch((err) => console.error(err)); // eslint-disable-line no-console
};

/**
 * @function subscribeBackButton
 * @description init native back button functionality
 */
const subScribeBackButton = async () => {
	try {
		await NativeSupportHandlerV2?.subscribeBackPress?.(backPressSuccessAction, backPressFailAction);
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

export const RouteToSwipeHome = () => {
	try {
		openDeepLinkWithoutCallback(`${MODULE_DEEPLINKS.PAYMENT_DASHBOARD}?wroute=swipe`);
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

const pageRoute = getURLParameter(window.location.href, 'pageRoute') || '';
const redirectUriDeeplink = getURLParameter(window.location.href, 'redirectUriDeeplink') || '';
const source = getURLParameter(window.location.href, 'source') || '';
const redirectFrom = loadState('redirectFrom', true);
const paymentTxnId = getURLParameter(window.location.href, 'paymentTxnId') || '';
const clientName = getURLParameter(window.location.href, 'client') || '';

const backPressSuccessAction = () => {
	sendPlotlineEvent('back_event_swipe', 'trigger');
	if (window.location.hash === '#/' || window.location.hash.includes('order-details')) {
		RouteToSwipeHome();
		return;
	}
	if (window.location.hash.includes('verify-kyc-docs') || window.location.hash.includes('cpv-hold')) {
		if (window.location.hash.includes('orderDetails')) {
			window.history.back();
			return;
		}
		RouteToSwipeHome();
		return;
	}
	const isV2OrderFlow = loadState('v2OrderFlow', true);
	if (isV2OrderFlow) {
		if (window.location.hash.includes('process-payment') && pageRoute === 'bp-one-landing') {
			window.location.href = '#/bharatpe-one-plan';
			return;
		}
		if (window.location.hash.includes('process-payment') || window.location.hash.includes('process-kyc')) {
			if (clientName === 'merchant-order-listing') {
				closeNativeSupport();
				return;
			}
			RouteToSwipeHome();
			return;
		}
		if (window.location.hash.includes('select-device') || window.location.hash.includes('upgrade-device-offer')) {
			if (window.location.hash.includes('newOrder')) {
				RouteToSwipeHome();
				return;
			}
		}
		if (window.location.hash.includes('select-plan')) {
			if (window.location.hash.includes('skip')) {
				if (clientName === 'rewards-hub' || clientName === 'merchant-order-listing') {
					closeNativeSupport();
					return;
				}
				if (window.location.hash.includes('processPayment')) {
					window.history.go(-2);
					return;
				}
				if (pageRoute === 'bp-one-landing') {
					window.history.go(-4);
					return;
				}
				RouteToSwipeHome();
				return;
			}
		}
		if (window.location.hash.includes('business-details')) {
			if (window.location.hash.includes('newOrder')) {
				const currentStage = 2;
				const startingStage = Number(loadState('startingStage', true) || currentStage);
				if (startingStage < currentStage) {
					window.history.back();
					return;
				}
				if (clientName === 'merchant-order-listing') {
					closeNativeSupport();
					return;
				}
				RouteToSwipeHome();
				return;
			}
		}
		if (window.location.hash.includes('business-details-form')) {
			if (window.location.hash.includes('edit')) {
				window.history.back();
				return;
			}
			const currentStage = 2;
			const startingStage = Number(loadState('startingStage', true) || currentStage);
			if (startingStage < currentStage) {
				window.history.go(-2);
				return;
			}
			RouteToSwipeHome();
			return;
		}
		if (window.location.hash.includes('select-address')) {
			if (window.location.hash.includes('newOrder')) {
				const currentStage = 4;
				const startingStage = Number(loadState('startingStage', true) || currentStage);
				if (startingStage < currentStage) {
					//[OLD FLOW]
					if (startingStage < 3) {
						window.history.go(-2);
						return;
					}
					removeState('isKycDocScreenOpenedOnce', true);
					window.history.back();
					return;
				}
				if (clientName === 'merchant-order-listing') {
					closeNativeSupport();
					return;
				}
				RouteToSwipeHome();
				return;
			}
		}
		if (window.location.hash.includes('add-new-address')) {
			if (window.location.hash.includes('newOrder')) {
				const currentStage = 4;
				const startingStage = Number(loadState('startingStage', true) || currentStage);
				if (startingStage < currentStage) {
					//[OLD FLOW] This means new address was added but continuous flow so go back to business-docs which was 4 pages ago
					if (startingStage < 3) {
						window.history.go(-4);
						return;
					}
					//means continuous flow and added a new address
					removeState('isKycDocScreenOpenedOnce', true);
					window.history.go(-3);
					return;
				}
				//means non continuous flow and added a new address
				RouteToSwipeHome();
				return;
			}
			//means came from processPayment and added a new address
			removeState('isKycDocScreenOpenedOnce', true);
			window.history.go(-3);
			return;
		}
		if (window.location.hash.includes('business-address') && window.location.hash.includes('newMerchant')) {
			// This means no address present in the list so directly landed here
			const currentStage = 4;
			const startingStage = Number(loadState('startingStage', true) || currentStage);
			if (startingStage < currentStage) {
				//This means continuous flow so go back to business-details-charges
				window.history.go(-2);
				return;
			}
			//This means no continuous flow so go back to swipe home
			RouteToSwipeHome();
			return;
		}
		if (window.location.hash.includes('bharatpe-one-plan')) {
			closeNativeSupport();
			return;
		}
		window.history.back();
		return;
	}

	if (window.location.hash.includes('product-pricing')) {
		window.location.href = '/';
		return;
	}
	if (window.location.hash.includes('swipe-migration-landing') && redirectUriDeeplink) {
		openDeepLinkWithoutCallback(atob(redirectUriDeeplink));
		return;
	}
	if (window.location.hash === '#/return/listing' && redirectFrom === 'migration-landing-page') {
		window.history.back();
		return;
	}
	if (window.location.hash.includes('return/1/status') || window.location.hash.includes('deactivate/1/status')) {
		RouteToSwipeHome();
		return;
	}
	if (window.location.hash.includes('return') && window.location.hash.includes('status')) {
		const isNavigateToPd = getURLParameter(window.location.href, 'serialNumber') || '';
		if (isNavigateToPd) {
			closeNativeSupport();
			return;
		}
	}
	if (window.location.hash.includes('deactivate') && window.location.hash.includes('status')) {
		RouteToSwipeHome();
		return;
	}
	if (window.location.hash.includes('statement') && window.location.hash.includes('pd')) {
		closeNativeSupport();
		return;
	}
	if (window.location.hash.includes('update-ranking') && source === 'link') {
		RouteToSwipeHome();
		return;
	}
	if (
		window.location.hash === '#/transactions-list' ||
		window.location.hash === '#/return/listing' ||
		window.location.hash.includes('pd') ||
		window.location.hash === '#/swipe-migration' ||
		window.location.hash === '#/swipe-migration-landing' ||
		window.location.hash === '#/swipe-pending-migration-landing' ||
		window.location.hash === '#/overdue-list' ||
		window.location.hash === '#/disputed-txn-list' ||
		window.location.hash === '#/update-ranking' ||
		window.location.hash === '#/service-request' ||
		window.location.hash.includes('bharatpe-one-plan') ||
		(window.location.hash === '#/cancellation-refund-status' && pageRoute === 'refund-status') ||
		(window.location.hash.includes('device-my-charges') &&
			pageRoute !== 'returnDeviceListing' &&
			pageRoute !== 'swipe-migration') ||
		paymentTxnId
	) {
		closeNativeSupport();
		return;
	}
	if (window.location.hash.includes('business-address') && window.location.hash.includes('newMerchant')) {
		window.location.href = '/';
		return;
	}
	if (window.location.hash.includes('cancellation-refund-status')) {
		RouteToSwipeHome();
		return;
	}
	if (window.location.hash.includes('refer-earn')) {
		RouteToSwipeHome();
		return;
	}
	window.history.back();
};

const backPressFailAction = () => {
	console.error('Native back failed.'); // eslint-disable-line no-console
};

export const openDeepLinkWithoutCallback = (deepLink: string) => {
	try {
		NativeSupportHandlerLegacy.openDeeplink(deepLink);
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

export const openDeepLinkWithCallback = (deepLink: string, callback?: CallableFunction) => {
	NativeSupportHandlerLegacy.openSimBindingDeepLink(deepLink)
		.then(() => callback && callback())
		.catch((error) => console.error(error)); // eslint-disable-line no-console
};

export const openCamera = async () => {
	try {
		const selectedImg = await NativeSupportHandlerLegacy.openBackCamera();
		return selectedImg;
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

export const sendCleverTapEvent = (event: any, payload1?: any) => {
	try {
		const newParams: any = {
			event_source: 'front_end',
			product: 'swipe',
			...event,
			...payload1,
		};
		NativeSupportHandlerLegacy.cleverTrackEvent('payment', newParams);
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

export const openDialer = async (phoneNumber: string) => {
	try {
		NativeSupportHandlerLegacy?.openDialer(phoneNumber);
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

export const openVideoDeeplink = (videoUrl: string) => {
	try {
		openDeepLinkWithCallback(`bharatpe://dynamic?key=bp-video&url=${videoUrl}`);
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

export const shareImage = (url: string, text: string, successCallBack: () => void) => {
	NativeSupportHandlerLegacy.callbackShareViaOthers(url, text)
		.then(() => successCallBack && successCallBack())
		.catch(() => Toasty.error(MSG_CONSTANT.FAILED_TO_SHARE));
};

export const sendPlotlineEvent = async (event_name: string, event_type: string) => {
	try {
		const request = {
			key: 110,
			payload: {
				event_name,
				event_type,
			},
		};

		await window.androidObj.nativeSupport(JSON.stringify(request));
		window.onPlotlineSdkCallback = () => console.log('Plotline event sent successfully.'); // eslint-disable-line no-console
	} catch (error) {
		console.error(error); // eslint-disable-line no-console
	}
};

export const savePermissionConsent = async (permission: string, source: string) => {
	NativeSupportHandlerLegacy.savePermissionConsent(permission, source)
		.then(() => {
			console.log('Permission consent saved');
		})
		.catch((err) => {
			console.log(err);
		});
};
